export enum MyuiLevel {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Neutral = 'neutral',
}

export function levelAttribute(value: unknown): MyuiLevel {
  if (Object.values(MyuiLevel).includes(value as MyuiLevel)) {
    return value as MyuiLevel;
  }

  return MyuiLevel.Primary;
}
